import DistributorProvider from './DistributorContext';
import Distributor from './Distributor';

let Index = () => {
    return (
        <DistributorProvider>
            <Distributor />
        </DistributorProvider>
    )
}

export default Index;